var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg010Support(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Question",
    d: "M270.8,13.5C128.5,13.1,13.1,128.5,13.5,270.8c.4,140.7,117.7,255.7,258.4,255.7h254.6v-254.6c0-140.7-115-258-255.7-258.4ZM292.8,400.7c-6.7,5.9-15,8.9-25,8.9s-18.3-3-25-8.9-10-13.5-10-22.7,3.3-16.8,10-22.7,15-8.9,25-8.9,18.3,3,25,8.9c6.7,5.9,10,13.5,10,22.7s-3.4,16.7-10,22.7ZM352.2,233c-4.1,8.5-10.7,17.2-19.8,26.1l-21.5,20c-6.1,5.9-10.4,11.9-12.7,18.1-2.4,6.2-3.7,14-3.9,23.5h-53.7c0-18.2,2.1-32.7,6.2-43.2,4.2-10.7,11.1-20.1,20-27.5,9.2-7.7,16.3-14.8,21.1-21.2,4.7-6.1,7.2-13.6,7.2-21.2,0-18.8-8.1-28.4-24.3-28.4-7-.2-13.7,2.8-18.1,8.2-4.6,5.5-7.1,12.9-7.3,22.3h-63.3c.3-25,8.1-44.5,23.6-58.4s37.3-20.9,65.2-20.9,49.5,6.4,64.8,19.3c15.3,12.9,22.9,31.2,22.9,54.9-.1,9.7-2.2,19.4-6.4,28.3h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg010Support);
export default __webpack_public_path__ + "static/media/010-support.02fe83f5082030cdb408fdea80b52704.svg";
export { ForwardRef as ReactComponent };